import "babel-polyfill";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "semantic-ui-css/semantic.min.css";
import "react-tippy/dist/tippy.css";
import { Provider } from "react-redux";
import { getStore } from "./store";
import mixpanel from "./services/mixpanel";
import MixpanelProvider from "react-mixpanel";
import { MuiThemeProvider, createMuiTheme } from "material-ui/styles";
import blue from "material-ui/colors/blue";
import { ravenUnHandledRejection } from "./services/raven";
import IS_CLIENT_RENDERED from "./util/isClientRendered";

if (IS_CLIENT_RENDERED) {
  window.onunhandledrejection = ravenUnHandledRejection;
}

//create Material Ui Theme
const theme = createMuiTheme({
  palette: {
    primary: {
      ...blue,
      A700: "#2394b8",
    },
  },
});
getStore().then(store => {
  ReactDOM.render(
    <MixpanelProvider mixpanel={mixpanel}>
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <App />
        </Provider>
      </MuiThemeProvider>
    </MixpanelProvider>,
    document.getElementById("root")
  );
});

// TODO - SSR find an alternative to this that doesn't cause circular dependency
export const dispatch = () => null;



// WEBPACK FOOTER //
// ./src/index.js